module.exports = __webpack_public_path__ + "img/01-1亚马逊云科技.e223c8ca.png";